import { createSelector } from 'reselect';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';
import { selectOrganizations } from '../organizations/selectors';

const isLoadingSelector = (statusKey) => (state) => state.authentication[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.authentication[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectCurrentUser = (state) => state.authentication?.currentUser;
export const selectUiRights = (state) => state.authentication?.uiRights;
export const selectUiRightsLoading = isLoadingSelector('getUiRightsStatus');

export const selectCanUseAiAssistant = (state) => Boolean(state.authentication?.uiRights?.ai_assistant_ui);

export const selectLoginWithPasswordLoading = isLoadingSelector('loginWithPasswordStatus');
export const selectLoginWithPasswordFailed = isFailedSelector('loginWithPasswordStatus');
export const selectLoginWithMicrosoftLoading = isLoadingSelector('loginWithMicrosoftStatus');
export const selectLoginWithMicrosoftFailed = isFailedSelector('loginWithMicrosoftStatus');
export const selectLoginWithPasswordAndApproveTermsOfUseLoading = isLoadingSelector(
  'loginWithPasswordAndApproveTermsOfUseStatus'
);
export const selectLoginWithPasswordAndApproveTermsOfUseFailed = isFailedSelector(
  'loginWithPasswordAndApproveTermsOfUseStatus'
);
export const selectLoginWithMicrosoftAndApproveTermsOfUseLoading = isLoadingSelector(
  'loginWithMicrosoftAndApproveTermsOfUseStatus'
);
export const selectLoginWithMicrosoftAndApproveTermsOfUseFailed = isFailedSelector(
  'loginWithMicrosoftAndApproveTermsOfUseStatus'
);

export const selectValidateUserLoading = isLoadingSelector('validateUserStatus');

export const selectAllowedSessionTypes = (state) => state.authentication?.allowedSessionTypes;
export const selectAllowedSessionTypesLoading = isLoadingSelector('allowedSessionTypesStatus');

export const selectApproveTermsOfUseLoading = isLoadingSelector('approveTermsOfUseStatus');
export const selectApproveTermsOfUseFailed = isFailedSelector('approveTermsOfUseStatus');

export const selectIsLoggedIn = (state) => !!state.authentication?.currentUser;

export const selectCurrentOrganization = createSelector(
  [selectCurrentUser, selectOrganizations],
  (currentUser, organizations) => {
    const organizationId = currentUser?.organization_id;

    if (!organizationId || !organizations) return null;

    return organizations.find((org) => org.id === organizationId) || null;
  }
);
